import React from 'react';
import ProfileForm, { PROFILE_MODES } from '../profile-form';

/**
 * Create New Profile Page
 * 
 * Thin wrapper around the unified ProfileForm component
 * configured for creating new profiles.
 */
const CreateProfile = () => {
  return <ProfileForm mode={PROFILE_MODES.CREATE} />;
};

export default CreateProfile;
